import { ISchema } from "@/shared/models/ISchema";
import { CdnSchemaJsonParsingResult } from "../models/CdnSchemaJsonParsingResult";
import { InjectableService } from "@/shared/services/InjectableService";



export abstract class SchemaJsonValidationService<TEntity, TJsonParsingInputType, TSchema extends ISchema> extends InjectableService {

    public abstract initializeValidators(defaultType?: string): void;
    public abstract tryParseEntitiesFromJson(value: string, configSchemas: Array<TSchema>): CdnSchemaJsonParsingResult<TEntity, TJsonParsingInputType>;
    public abstract initializeEntityWithConfiguration(entity: TEntity, configSchemas: Array<TSchema>): TEntity;
    public abstract initializeEntity(entity: TEntity, configSchemas: Array<TSchema>, configurationLevel: number) : TEntity;


}   